export type DashboardConfig = {
  mode: "local" | "cloud";
  apiBase: string;
  title: string;
};

declare global {
  interface Window {
    __DASHBOARD_CONFIG__?: Partial<DashboardConfig>;
  }
}

export function getDashboardConfig(): DashboardConfig {
  const configured = window.__DASHBOARD_CONFIG__ ?? {};
  const host = window.location.hostname;
  const guessedMode = host === "127.0.0.1" || host === "localhost" ? "local" : "cloud";
  const title = configured.title === "Minecraft Dashboard" ? "Minecraft ダッシュボード" : configured.title;
  return {
    mode: configured.mode ?? guessedMode,
    apiBase: configured.apiBase ?? "",
    title: title ?? "Minecraft ダッシュボード",
  };
}
